import LegalIA from "./LegalIA";

export default function IANormativa() {
  return <LegalIA modelo="normativo" />;
}
